module.exports = __webpack_public_path__ + "icons/videoplay.d91ea51f.svg";